import SSOJoinRules from '@/views/sso-join-rules/sso-join-rules-list.vue'
import AddSSOJoinRules from '@/views/sso-join-rules/sso-join-rules-new.vue'
import EditSSOJoinRules from '@/views/sso-join-rules/sso-join-rules-edit.vue'
import { SSOJoinRulesRouteNames } from '@/router/routes-names'

export const ssoJoinRules = [
    {
        path: '/sso-join-rules',
        name: SSOJoinRulesRouteNames.LIST,
        component: SSOJoinRules,
        props: true
    },
    {
        path: '/sso-join-rules/new',
        name: SSOJoinRulesRouteNames.NEW,
        component: AddSSOJoinRules
    },
    {
        path: '/sso-join-rules/edit/:id',
        name: SSOJoinRulesRouteNames.EDIT,
        component: EditSSOJoinRules
    }
]
